/**
 * Brand furniture for the public site.
 *
 * The mark is an aperture: a ring broken at the top-right, four alignment ticks,
 * and one resolved point inside it. It is the thesis in 24 pixels — the instrument
 * does not enlarge the field, it brings one point in it into focus.
 */
export function ObserverMark({ size = 26, className = '' }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      {/* Outer aperture, broken so the eye reads it as an instrument, not a bullet. */}
      <circle
        cx="16"
        cy="16"
        r="12.25"
        stroke="currentColor"
        strokeOpacity="0.32"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeDasharray="52 25"
        transform="rotate(-58 16 16)"
      />
      {/* Alignment ticks. */}
      <path
        d="M16 1.6v4.2M16 26.2v4.2M1.6 16h4.2M26.2 16h4.2"
        stroke="currentColor"
        strokeOpacity="0.28"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
      {/* Inner ring — the resolving element. */}
      <circle cx="16" cy="16" r="6.4" stroke="currentColor" strokeOpacity="0.75" strokeWidth="1.5" />
      {/* The point that resolved. */}
      <circle cx="16" cy="16" r="2.5" fill="currentColor" />
    </svg>
  );
}

export function Wordmark({ className = '' }: { className?: string }) {
  return (
    <span className={`text-[15.5px] font-medium tracking-[-0.03em] ${className}`}>
      <span className="text-bone">candidate</span>
      <span className="text-signal">.</span>
      <span className="text-bone/60">observer</span>
    </span>
  );
}

export function BrandLockup({ size = 26, className = '' }: { size?: number; className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <span className="text-signal">
        <ObserverMark size={size} />
      </span>
      <Wordmark />
    </span>
  );
}

/**
 * The mark and the wordmark together, which is what a page header wants nine
 * times out of ten. The pieces stay exported for the tenth.
 */
export default BrandLockup;
